var exports = {
  "P": "xfd349460--0e97a9--observer-wrapper",
};

module.exports = exports;
